export enum RelationshipToPolicyHolder {
  Self = 'SELF',
  Spouse = 'SPOUSE',
  Child = 'CHILD',
  Other = 'OTHER',
}

export enum ClaimExpectingPayment {
  NO_BEFORE_PA_START_DATE = 'No (Before PA Start Date)',
  NO_EXPERIMENTALLY_BILLED = 'No (Experimentally Billed)',
  YES_FULLY_BILLABLE = 'Yes (Fully Billable)',
}

export enum PayorTypes {
  MedicarePartA = 'Medicare Part A',
  MedicarePartB = 'Medicare Part B',
  Medicaid = 'Medicaid',
  Tricare = 'Tricare',
  ChampVa = 'ChampVa',
  GroupHealthPlan = 'Group Health Plan',
  FecaBlkLung = 'FECA Blk Lung',
  Other = 'Other',
}

export enum ServiceCodeTypes {
  Cpt = 'CPT',
  Hcpcs = 'HCPCS',
}

export enum ClaimSubmissionMethod {
  AVAILITY = 'Availity',
  CHANGE_HEALTHCARE = 'Change Healthcare',
  FAX = 'Fax',
  PAYOR_PORTAL = 'Payor Portal',
  TEBRA = 'Tebra',
}
export enum ClaimRejectionReason {
  CLAIM_NOT_ON_FILE = 'Claim Not On File',
  DUPLICATE_CLAIM = 'Duplicate Claim',
  NEEDS_ALTERNATE_SUBMISSION_METHOD = 'Needs Alternate Submission Method',
  NEEDS_C_AND_C = 'Needs C&C',
  NEEDS_COB_UPDATE = 'Needs COB Update',
  NEEDS_CORRECTED_CLAIM = 'Needs Corrected Claim',
  NEEDS_EFT_SETUP = 'Needs EFT Setup',
  NEEDS_MEDICAL_RECORDS = 'Needs Medical Records',
  NEEDS_PA_SCA = 'Needs PA / SCA',
  NEEDS_W9 = 'Needs W9',
  NO_ABA_COVERAGE = 'No ABA Coverage',
  TERMINATED_INSURANCE = 'Termed Insurance',
  TIMELY_FILING = 'Timely Filing',
}

export enum ClaimPaymentStatus {
  CHECK_RECEIVED = 'Check received',
  EFT_RECEIVED = 'EFT received',
  NOT_PAID = 'Not paid',
  VIRTUAL_CC_RECEIVED = 'Virtual cc received',
  PARTIAL_PAYMENT_RECEIVED = 'Partial payment received',
  PAID_TO_SUBSCRIBER = 'Paid to Subscriber',
}
